/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CheckEmailRouteImport } from './routes/check-email'
import { Route as R403RouteImport } from './routes/403'
import { Route as VendorRouteRouteImport } from './routes/vendor/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VendorIndexRouteImport } from './routes/vendor/index'
import { Route as VendorLoginRouteImport } from './routes/vendor/login'
import { Route as VendorDashboardRouteImport } from './routes/vendor/dashboard'
import { Route as VendorTransferIndexRouteImport } from './routes/vendor/transfer/index'
import { Route as VendorStockIndexRouteImport } from './routes/vendor/stock/index'
import { Route as VendorStockInRequestIndexRouteImport } from './routes/vendor/stock-in-request/index'
import { Route as VendorSalesIndexRouteImport } from './routes/vendor/sales/index'
import { Route as VendorRentalIndexRouteImport } from './routes/vendor/rental/index'
import { Route as VendorProductsIndexRouteImport } from './routes/vendor/products/index'
import { Route as VendorInventoryCountIndexRouteImport } from './routes/vendor/inventory-count/index'
import { Route as VendorStockInRequestNewRouteImport } from './routes/vendor/stock-in-request/new'
import { Route as VendorStockInRequestConsignmentStockInRequestIDRouteImport } from './routes/vendor/stock-in-request/$consignmentStockInRequestID'
import { Route as VendorSalesSalesConsignmentInvoiceIDRouteImport } from './routes/vendor/sales/$salesConsignmentInvoiceID'
import { Route as VendorRentalNewRouteImport } from './routes/vendor/rental/new'
import { Route as VendorProductsProductIDRouteImport } from './routes/vendor/products/$productID'
import { Route as VendorInventoryCountProductIDRouteImport } from './routes/vendor/inventory-count/$productID'
import { Route as AuthResetPasswordTokenRouteImport } from './routes/auth/reset-password/$token'
import { Route as VendorStockProductIDIndexRouteImport } from './routes/vendor/stock/$productID/index'
import { Route as VendorRentalVendorConsignmentRentalPaymentIDIndexRouteImport } from './routes/vendor/rental/$vendorConsignmentRentalPaymentID/index'
import { Route as VendorTransferTypeIdRouteImport } from './routes/vendor/transfer/$type/$id'
import { Route as VendorStockProductIDInventoryRouteImport } from './routes/vendor/stock/$productID/inventory'
import { Route as VendorRentalVendorConsignmentRentalPaymentIDPrintRouteImport } from './routes/vendor/rental/$vendorConsignmentRentalPaymentID/print'
import { Route as VendorRentalVendorConsignmentRentalPaymentIDEditRouteImport } from './routes/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
import { Route as VendorAuthResetPasswordTokenRouteImport } from './routes/vendor/auth/reset-password/$token'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckEmailRoute = CheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorRouteRoute = VendorRouteRouteImport.update({
  id: '/vendor',
  path: '/vendor',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorIndexRoute = VendorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorLoginRoute = VendorLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorDashboardRoute = VendorDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorTransferIndexRoute = VendorTransferIndexRouteImport.update({
  id: '/transfer/',
  path: '/transfer/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorStockIndexRoute = VendorStockIndexRouteImport.update({
  id: '/stock/',
  path: '/stock/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorStockInRequestIndexRoute =
  VendorStockInRequestIndexRouteImport.update({
    id: '/stock-in-request/',
    path: '/stock-in-request/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorSalesIndexRoute = VendorSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorRentalIndexRoute = VendorRentalIndexRouteImport.update({
  id: '/rental/',
  path: '/rental/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorProductsIndexRoute = VendorProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorInventoryCountIndexRoute =
  VendorInventoryCountIndexRouteImport.update({
    id: '/inventory-count/',
    path: '/inventory-count/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorStockInRequestNewRoute = VendorStockInRequestNewRouteImport.update({
  id: '/stock-in-request/new',
  path: '/stock-in-request/new',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorStockInRequestConsignmentStockInRequestIDRoute =
  VendorStockInRequestConsignmentStockInRequestIDRouteImport.update({
    id: '/stock-in-request/$consignmentStockInRequestID',
    path: '/stock-in-request/$consignmentStockInRequestID',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorSalesSalesConsignmentInvoiceIDRoute =
  VendorSalesSalesConsignmentInvoiceIDRouteImport.update({
    id: '/sales/$salesConsignmentInvoiceID',
    path: '/sales/$salesConsignmentInvoiceID',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRentalNewRoute = VendorRentalNewRouteImport.update({
  id: '/rental/new',
  path: '/rental/new',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorProductsProductIDRoute = VendorProductsProductIDRouteImport.update({
  id: '/products/$productID',
  path: '/products/$productID',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorInventoryCountProductIDRoute =
  VendorInventoryCountProductIDRouteImport.update({
    id: '/inventory-count/$productID',
    path: '/inventory-count/$productID',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const AuthResetPasswordTokenRoute = AuthResetPasswordTokenRouteImport.update({
  id: '/auth/reset-password/$token',
  path: '/auth/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorStockProductIDIndexRoute =
  VendorStockProductIDIndexRouteImport.update({
    id: '/stock/$productID/',
    path: '/stock/$productID/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRentalVendorConsignmentRentalPaymentIDIndexRoute =
  VendorRentalVendorConsignmentRentalPaymentIDIndexRouteImport.update({
    id: '/rental/$vendorConsignmentRentalPaymentID/',
    path: '/rental/$vendorConsignmentRentalPaymentID/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorTransferTypeIdRoute = VendorTransferTypeIdRouteImport.update({
  id: '/transfer/$type/$id',
  path: '/transfer/$type/$id',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorStockProductIDInventoryRoute =
  VendorStockProductIDInventoryRouteImport.update({
    id: '/stock/$productID/inventory',
    path: '/stock/$productID/inventory',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRentalVendorConsignmentRentalPaymentIDPrintRoute =
  VendorRentalVendorConsignmentRentalPaymentIDPrintRouteImport.update({
    id: '/rental/$vendorConsignmentRentalPaymentID/print',
    path: '/rental/$vendorConsignmentRentalPaymentID/print',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorRentalVendorConsignmentRentalPaymentIDEditRoute =
  VendorRentalVendorConsignmentRentalPaymentIDEditRouteImport.update({
    id: '/rental/$vendorConsignmentRentalPaymentID/edit',
    path: '/rental/$vendorConsignmentRentalPaymentID/edit',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorAuthResetPasswordTokenRoute =
  VendorAuthResetPasswordTokenRouteImport.update({
    id: '/auth/reset-password/$token',
    path: '/auth/reset-password/$token',
    getParentRoute: () => VendorRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/vendor': typeof VendorRouteRouteWithChildren
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/vendor/dashboard': typeof VendorDashboardRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor/': typeof VendorIndexRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/vendor/inventory-count/$productID': typeof VendorInventoryCountProductIDRoute
  '/vendor/products/$productID': typeof VendorProductsProductIDRoute
  '/vendor/rental/new': typeof VendorRentalNewRoute
  '/vendor/sales/$salesConsignmentInvoiceID': typeof VendorSalesSalesConsignmentInvoiceIDRoute
  '/vendor/stock-in-request/$consignmentStockInRequestID': typeof VendorStockInRequestConsignmentStockInRequestIDRoute
  '/vendor/stock-in-request/new': typeof VendorStockInRequestNewRoute
  '/vendor/inventory-count': typeof VendorInventoryCountIndexRoute
  '/vendor/products': typeof VendorProductsIndexRoute
  '/vendor/rental': typeof VendorRentalIndexRoute
  '/vendor/sales': typeof VendorSalesIndexRoute
  '/vendor/stock-in-request': typeof VendorStockInRequestIndexRoute
  '/vendor/stock': typeof VendorStockIndexRoute
  '/vendor/transfer': typeof VendorTransferIndexRoute
  '/vendor/auth/reset-password/$token': typeof VendorAuthResetPasswordTokenRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/edit': typeof VendorRentalVendorConsignmentRentalPaymentIDEditRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/print': typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRoute
  '/vendor/stock/$productID/inventory': typeof VendorStockProductIDInventoryRoute
  '/vendor/transfer/$type/$id': typeof VendorTransferTypeIdRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID': typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRoute
  '/vendor/stock/$productID': typeof VendorStockProductIDIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/vendor/dashboard': typeof VendorDashboardRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor': typeof VendorIndexRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/vendor/inventory-count/$productID': typeof VendorInventoryCountProductIDRoute
  '/vendor/products/$productID': typeof VendorProductsProductIDRoute
  '/vendor/rental/new': typeof VendorRentalNewRoute
  '/vendor/sales/$salesConsignmentInvoiceID': typeof VendorSalesSalesConsignmentInvoiceIDRoute
  '/vendor/stock-in-request/$consignmentStockInRequestID': typeof VendorStockInRequestConsignmentStockInRequestIDRoute
  '/vendor/stock-in-request/new': typeof VendorStockInRequestNewRoute
  '/vendor/inventory-count': typeof VendorInventoryCountIndexRoute
  '/vendor/products': typeof VendorProductsIndexRoute
  '/vendor/rental': typeof VendorRentalIndexRoute
  '/vendor/sales': typeof VendorSalesIndexRoute
  '/vendor/stock-in-request': typeof VendorStockInRequestIndexRoute
  '/vendor/stock': typeof VendorStockIndexRoute
  '/vendor/transfer': typeof VendorTransferIndexRoute
  '/vendor/auth/reset-password/$token': typeof VendorAuthResetPasswordTokenRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/edit': typeof VendorRentalVendorConsignmentRentalPaymentIDEditRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/print': typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRoute
  '/vendor/stock/$productID/inventory': typeof VendorStockProductIDInventoryRoute
  '/vendor/transfer/$type/$id': typeof VendorTransferTypeIdRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID': typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRoute
  '/vendor/stock/$productID': typeof VendorStockProductIDIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/vendor': typeof VendorRouteRouteWithChildren
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/vendor/dashboard': typeof VendorDashboardRoute
  '/vendor/login': typeof VendorLoginRoute
  '/vendor/': typeof VendorIndexRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/vendor/inventory-count/$productID': typeof VendorInventoryCountProductIDRoute
  '/vendor/products/$productID': typeof VendorProductsProductIDRoute
  '/vendor/rental/new': typeof VendorRentalNewRoute
  '/vendor/sales/$salesConsignmentInvoiceID': typeof VendorSalesSalesConsignmentInvoiceIDRoute
  '/vendor/stock-in-request/$consignmentStockInRequestID': typeof VendorStockInRequestConsignmentStockInRequestIDRoute
  '/vendor/stock-in-request/new': typeof VendorStockInRequestNewRoute
  '/vendor/inventory-count/': typeof VendorInventoryCountIndexRoute
  '/vendor/products/': typeof VendorProductsIndexRoute
  '/vendor/rental/': typeof VendorRentalIndexRoute
  '/vendor/sales/': typeof VendorSalesIndexRoute
  '/vendor/stock-in-request/': typeof VendorStockInRequestIndexRoute
  '/vendor/stock/': typeof VendorStockIndexRoute
  '/vendor/transfer/': typeof VendorTransferIndexRoute
  '/vendor/auth/reset-password/$token': typeof VendorAuthResetPasswordTokenRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/edit': typeof VendorRentalVendorConsignmentRentalPaymentIDEditRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/print': typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRoute
  '/vendor/stock/$productID/inventory': typeof VendorStockProductIDInventoryRoute
  '/vendor/transfer/$type/$id': typeof VendorTransferTypeIdRoute
  '/vendor/rental/$vendorConsignmentRentalPaymentID/': typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRoute
  '/vendor/stock/$productID/': typeof VendorStockProductIDIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/vendor'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/vendor/dashboard'
    | '/vendor/login'
    | '/vendor/'
    | '/auth/reset-password/$token'
    | '/vendor/inventory-count/$productID'
    | '/vendor/products/$productID'
    | '/vendor/rental/new'
    | '/vendor/sales/$salesConsignmentInvoiceID'
    | '/vendor/stock-in-request/$consignmentStockInRequestID'
    | '/vendor/stock-in-request/new'
    | '/vendor/inventory-count'
    | '/vendor/products'
    | '/vendor/rental'
    | '/vendor/sales'
    | '/vendor/stock-in-request'
    | '/vendor/stock'
    | '/vendor/transfer'
    | '/vendor/auth/reset-password/$token'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
    | '/vendor/stock/$productID/inventory'
    | '/vendor/transfer/$type/$id'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID'
    | '/vendor/stock/$productID'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/vendor/dashboard'
    | '/vendor/login'
    | '/vendor'
    | '/auth/reset-password/$token'
    | '/vendor/inventory-count/$productID'
    | '/vendor/products/$productID'
    | '/vendor/rental/new'
    | '/vendor/sales/$salesConsignmentInvoiceID'
    | '/vendor/stock-in-request/$consignmentStockInRequestID'
    | '/vendor/stock-in-request/new'
    | '/vendor/inventory-count'
    | '/vendor/products'
    | '/vendor/rental'
    | '/vendor/sales'
    | '/vendor/stock-in-request'
    | '/vendor/stock'
    | '/vendor/transfer'
    | '/vendor/auth/reset-password/$token'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
    | '/vendor/stock/$productID/inventory'
    | '/vendor/transfer/$type/$id'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID'
    | '/vendor/stock/$productID'
  id:
    | '__root__'
    | '/'
    | '/vendor'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/vendor/dashboard'
    | '/vendor/login'
    | '/vendor/'
    | '/auth/reset-password/$token'
    | '/vendor/inventory-count/$productID'
    | '/vendor/products/$productID'
    | '/vendor/rental/new'
    | '/vendor/sales/$salesConsignmentInvoiceID'
    | '/vendor/stock-in-request/$consignmentStockInRequestID'
    | '/vendor/stock-in-request/new'
    | '/vendor/inventory-count/'
    | '/vendor/products/'
    | '/vendor/rental/'
    | '/vendor/sales/'
    | '/vendor/stock-in-request/'
    | '/vendor/stock/'
    | '/vendor/transfer/'
    | '/vendor/auth/reset-password/$token'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
    | '/vendor/stock/$productID/inventory'
    | '/vendor/transfer/$type/$id'
    | '/vendor/rental/$vendorConsignmentRentalPaymentID/'
    | '/vendor/stock/$productID/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  VendorRouteRoute: typeof VendorRouteRouteWithChildren
  R403Route: typeof R403Route
  CheckEmailRoute: typeof CheckEmailRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  AuthResetPasswordTokenRoute: typeof AuthResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-email': {
      id: '/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof CheckEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor': {
      id: '/vendor'
      path: '/vendor'
      fullPath: '/vendor'
      preLoaderRoute: typeof VendorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor/': {
      id: '/vendor/'
      path: '/'
      fullPath: '/vendor/'
      preLoaderRoute: typeof VendorIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/login': {
      id: '/vendor/login'
      path: '/login'
      fullPath: '/vendor/login'
      preLoaderRoute: typeof VendorLoginRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/dashboard': {
      id: '/vendor/dashboard'
      path: '/dashboard'
      fullPath: '/vendor/dashboard'
      preLoaderRoute: typeof VendorDashboardRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/transfer/': {
      id: '/vendor/transfer/'
      path: '/transfer'
      fullPath: '/vendor/transfer'
      preLoaderRoute: typeof VendorTransferIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock/': {
      id: '/vendor/stock/'
      path: '/stock'
      fullPath: '/vendor/stock'
      preLoaderRoute: typeof VendorStockIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock-in-request/': {
      id: '/vendor/stock-in-request/'
      path: '/stock-in-request'
      fullPath: '/vendor/stock-in-request'
      preLoaderRoute: typeof VendorStockInRequestIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/sales/': {
      id: '/vendor/sales/'
      path: '/sales'
      fullPath: '/vendor/sales'
      preLoaderRoute: typeof VendorSalesIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/': {
      id: '/vendor/rental/'
      path: '/rental'
      fullPath: '/vendor/rental'
      preLoaderRoute: typeof VendorRentalIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/products/': {
      id: '/vendor/products/'
      path: '/products'
      fullPath: '/vendor/products'
      preLoaderRoute: typeof VendorProductsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/inventory-count/': {
      id: '/vendor/inventory-count/'
      path: '/inventory-count'
      fullPath: '/vendor/inventory-count'
      preLoaderRoute: typeof VendorInventoryCountIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock-in-request/new': {
      id: '/vendor/stock-in-request/new'
      path: '/stock-in-request/new'
      fullPath: '/vendor/stock-in-request/new'
      preLoaderRoute: typeof VendorStockInRequestNewRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock-in-request/$consignmentStockInRequestID': {
      id: '/vendor/stock-in-request/$consignmentStockInRequestID'
      path: '/stock-in-request/$consignmentStockInRequestID'
      fullPath: '/vendor/stock-in-request/$consignmentStockInRequestID'
      preLoaderRoute: typeof VendorStockInRequestConsignmentStockInRequestIDRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/sales/$salesConsignmentInvoiceID': {
      id: '/vendor/sales/$salesConsignmentInvoiceID'
      path: '/sales/$salesConsignmentInvoiceID'
      fullPath: '/vendor/sales/$salesConsignmentInvoiceID'
      preLoaderRoute: typeof VendorSalesSalesConsignmentInvoiceIDRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/new': {
      id: '/vendor/rental/new'
      path: '/rental/new'
      fullPath: '/vendor/rental/new'
      preLoaderRoute: typeof VendorRentalNewRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/products/$productID': {
      id: '/vendor/products/$productID'
      path: '/products/$productID'
      fullPath: '/vendor/products/$productID'
      preLoaderRoute: typeof VendorProductsProductIDRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/inventory-count/$productID': {
      id: '/vendor/inventory-count/$productID'
      path: '/inventory-count/$productID'
      fullPath: '/vendor/inventory-count/$productID'
      preLoaderRoute: typeof VendorInventoryCountProductIDRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/auth/reset-password/$token': {
      id: '/auth/reset-password/$token'
      path: '/auth/reset-password/$token'
      fullPath: '/auth/reset-password/$token'
      preLoaderRoute: typeof AuthResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor/stock/$productID/': {
      id: '/vendor/stock/$productID/'
      path: '/stock/$productID'
      fullPath: '/vendor/stock/$productID'
      preLoaderRoute: typeof VendorStockProductIDIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/$vendorConsignmentRentalPaymentID/': {
      id: '/vendor/rental/$vendorConsignmentRentalPaymentID/'
      path: '/rental/$vendorConsignmentRentalPaymentID'
      fullPath: '/vendor/rental/$vendorConsignmentRentalPaymentID'
      preLoaderRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/transfer/$type/$id': {
      id: '/vendor/transfer/$type/$id'
      path: '/transfer/$type/$id'
      fullPath: '/vendor/transfer/$type/$id'
      preLoaderRoute: typeof VendorTransferTypeIdRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/stock/$productID/inventory': {
      id: '/vendor/stock/$productID/inventory'
      path: '/stock/$productID/inventory'
      fullPath: '/vendor/stock/$productID/inventory'
      preLoaderRoute: typeof VendorStockProductIDInventoryRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/$vendorConsignmentRentalPaymentID/print': {
      id: '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
      path: '/rental/$vendorConsignmentRentalPaymentID/print'
      fullPath: '/vendor/rental/$vendorConsignmentRentalPaymentID/print'
      preLoaderRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/rental/$vendorConsignmentRentalPaymentID/edit': {
      id: '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
      path: '/rental/$vendorConsignmentRentalPaymentID/edit'
      fullPath: '/vendor/rental/$vendorConsignmentRentalPaymentID/edit'
      preLoaderRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDEditRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/auth/reset-password/$token': {
      id: '/vendor/auth/reset-password/$token'
      path: '/auth/reset-password/$token'
      fullPath: '/vendor/auth/reset-password/$token'
      preLoaderRoute: typeof VendorAuthResetPasswordTokenRouteImport
      parentRoute: typeof VendorRouteRoute
    }
  }
}

interface VendorRouteRouteChildren {
  VendorDashboardRoute: typeof VendorDashboardRoute
  VendorLoginRoute: typeof VendorLoginRoute
  VendorIndexRoute: typeof VendorIndexRoute
  VendorInventoryCountProductIDRoute: typeof VendorInventoryCountProductIDRoute
  VendorProductsProductIDRoute: typeof VendorProductsProductIDRoute
  VendorRentalNewRoute: typeof VendorRentalNewRoute
  VendorSalesSalesConsignmentInvoiceIDRoute: typeof VendorSalesSalesConsignmentInvoiceIDRoute
  VendorStockInRequestConsignmentStockInRequestIDRoute: typeof VendorStockInRequestConsignmentStockInRequestIDRoute
  VendorStockInRequestNewRoute: typeof VendorStockInRequestNewRoute
  VendorInventoryCountIndexRoute: typeof VendorInventoryCountIndexRoute
  VendorProductsIndexRoute: typeof VendorProductsIndexRoute
  VendorRentalIndexRoute: typeof VendorRentalIndexRoute
  VendorSalesIndexRoute: typeof VendorSalesIndexRoute
  VendorStockInRequestIndexRoute: typeof VendorStockInRequestIndexRoute
  VendorStockIndexRoute: typeof VendorStockIndexRoute
  VendorTransferIndexRoute: typeof VendorTransferIndexRoute
  VendorAuthResetPasswordTokenRoute: typeof VendorAuthResetPasswordTokenRoute
  VendorRentalVendorConsignmentRentalPaymentIDEditRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDEditRoute
  VendorRentalVendorConsignmentRentalPaymentIDPrintRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDPrintRoute
  VendorStockProductIDInventoryRoute: typeof VendorStockProductIDInventoryRoute
  VendorTransferTypeIdRoute: typeof VendorTransferTypeIdRoute
  VendorRentalVendorConsignmentRentalPaymentIDIndexRoute: typeof VendorRentalVendorConsignmentRentalPaymentIDIndexRoute
  VendorStockProductIDIndexRoute: typeof VendorStockProductIDIndexRoute
}

const VendorRouteRouteChildren: VendorRouteRouteChildren = {
  VendorDashboardRoute: VendorDashboardRoute,
  VendorLoginRoute: VendorLoginRoute,
  VendorIndexRoute: VendorIndexRoute,
  VendorInventoryCountProductIDRoute: VendorInventoryCountProductIDRoute,
  VendorProductsProductIDRoute: VendorProductsProductIDRoute,
  VendorRentalNewRoute: VendorRentalNewRoute,
  VendorSalesSalesConsignmentInvoiceIDRoute:
    VendorSalesSalesConsignmentInvoiceIDRoute,
  VendorStockInRequestConsignmentStockInRequestIDRoute:
    VendorStockInRequestConsignmentStockInRequestIDRoute,
  VendorStockInRequestNewRoute: VendorStockInRequestNewRoute,
  VendorInventoryCountIndexRoute: VendorInventoryCountIndexRoute,
  VendorProductsIndexRoute: VendorProductsIndexRoute,
  VendorRentalIndexRoute: VendorRentalIndexRoute,
  VendorSalesIndexRoute: VendorSalesIndexRoute,
  VendorStockInRequestIndexRoute: VendorStockInRequestIndexRoute,
  VendorStockIndexRoute: VendorStockIndexRoute,
  VendorTransferIndexRoute: VendorTransferIndexRoute,
  VendorAuthResetPasswordTokenRoute: VendorAuthResetPasswordTokenRoute,
  VendorRentalVendorConsignmentRentalPaymentIDEditRoute:
    VendorRentalVendorConsignmentRentalPaymentIDEditRoute,
  VendorRentalVendorConsignmentRentalPaymentIDPrintRoute:
    VendorRentalVendorConsignmentRentalPaymentIDPrintRoute,
  VendorStockProductIDInventoryRoute: VendorStockProductIDInventoryRoute,
  VendorTransferTypeIdRoute: VendorTransferTypeIdRoute,
  VendorRentalVendorConsignmentRentalPaymentIDIndexRoute:
    VendorRentalVendorConsignmentRentalPaymentIDIndexRoute,
  VendorStockProductIDIndexRoute: VendorStockProductIDIndexRoute,
}

const VendorRouteRouteWithChildren = VendorRouteRoute._addFileChildren(
  VendorRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  VendorRouteRoute: VendorRouteRouteWithChildren,
  R403Route: R403Route,
  CheckEmailRoute: CheckEmailRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  AuthResetPasswordTokenRoute: AuthResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
